module.exports = __webpack_public_path__ + "static/textselection-e168f92fb9077a92d21921a79e5cd988.mp4";